import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getName } from "country-list";
import {
  updateEmployee,
  getEmployeeDetails,
  setEmployeeData,
} from "./employeeSlice";
const IBAN_REGEX = /^[A-Z]{2}[0-9A-Z]{1,30}$/;
const useEditBankInformation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isSaveBtn, setIsSaveBtn] = useState(false);
  const [isError, setShowError] = useState(false);
  const [bankData, setBankData] = useState({});
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  const toastRef = useRef(null);

  const [generalInfo, setGeninfo] = useState({});

  const { isDataAvailable, employeeDetails } = useSelector(
    (state) => state.employeeregister,
  );

  const initializeData = () => ({
    bank_account_holder_name: employeeDetails?.bank_account_holder_name || "",
    bank_name: employeeDetails?.bank_name || "",
    bank_account_number: employeeDetails?.bank_account_number || "",
    bank_swift_bic: employeeDetails?.bank_swift_bic || "",
    bank_account_currency: employeeDetails?.bank_account_currency || "",
    bank_branch_address: employeeDetails?.bank_branch_address || "",
    bank_country:
      (employeeDetails?.bank_country &&
        normalizeCountry(employeeDetails?.bank_country)) ||
      "",
  });

  useEffect(() => {
    handleSet();
  }, [employeeDetails, dispatch]);

  const handleSet = () => {
    const initialData = initializeData();
    setGeninfo(initialData);
    setBankData(initialData);
  };

  const onChangeBankInformation = (name, value) => {
    setBankData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  function normalizeCountry(value) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) {
      return {
        name: value && getName(value),
        code: value,
      };
    }
    return value;
  }
  const areObjectsEqual = (obj1 = {}, obj2 = {}) => {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }
    return Object.keys(obj1).every((key) => obj1[key] === obj2[key]);
  };
  useEffect(() => {
    const isIdentical = areObjectsEqual(generalInfo, bankData);
    const isInfoValid =
      bankData?.bank_account_number &&
      !IBAN_REGEX.test(bankData?.bank_account_number || "");
    setIsSaveBtn(isInfoValid || isIdentical);
  }, [bankData, generalInfo]);

  const handleDiscardEdit = () => {
    handleSet();
    setIsUpdating(false);
    setIsSaveBtn(false);
    setIsEdit(false);
  };
  const handleEnableEdit = () => {
    setIsUpdating(false);
    setIsSaveBtn(true);
    setIsEdit(true);
  };
  const handleUpdate = async () => {
    setShowError(false);
    setIsUpdating(true);
    try {
      let data = {
        bank_account_holder_name: bankData?.bank_account_holder_name || "",
        bank_name: bankData?.bank_name || "",
        bank_account_number: bankData?.bank_account_number || "",
        bank_swift_bic: bankData?.bank_swift_bic || "",
        bank_account_currency: bankData?.bank_account_currency || "",
        bank_branch_address: bankData?.bank_branch_address || "",
        bank_country: bankData.bank_country?.code || null,
      };

      await dispatch(
        updateEmployee({ id, data: { ...employeeDetails, ...data } }),
      ).unwrap();
      toastRef.current.show({
        severity: "success",
        summary: "Bank Information",
        detail: "has been updated!",
        icon: "pi pi-check",
      });
      dispatch(
        setEmployeeData({
          key: "employeeDetails",
          value: {
            ...employeeDetails,
            ...data,
          },
        }),
      );
      // dispatch(setEmployeeData({ key: "loading", value: true }));
      // setTimeout(async () => {
      //   await dispatch(getEmployeeDetails(id)).unwrap();
      // }, 1000);

      handleDiscardEdit();
    } catch (error) {
      setShowError(true);
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    onChangeBankInformation,
    handleDiscardEdit,
    handleEnableEdit,
    handleUpdate,
    setShowError,
    setAuditSidebarVisible,
    bankData,
    toastRef,
    states: {
      isEdit,
      isError,
      loading: !isDataAvailable,
      isUpdating,
      isSaveBtn,
      isAuditSidebarVisible,
    },
  };
};

export default useEditBankInformation;
